<template>
    <div class="sps-card sps-card--articles">
        <div class="sps-card__title">{{ lc.title || $t("shell.searchArticles") }}</div>
        <input v-if="card.showSearch !== false" v-model="q" class="sps-card__search" type="search" :placeholder="$t('shell.searchPlaceholder')" @input="onSearch" />
        <ul class="sps-card__list">
            <li v-for="a in list" :key="a._id"><button type="button" @click="$emit('open-article', a)">{{ titleOf(a) }}<span aria-hidden="true">›</span></button></li>
        </ul>
        <p v-if="!loading && !list.length" class="sps-card__empty">{{ $t("shell.noArticles") }}</p>
    </div>
</template>
<script>
import { mapState } from "vuex";
import _ from "lodash";
import { pickLanguageContent } from "../../../../utils/shell/pickLanguageContent";
export default {
    name: "ArticlesCard",
    props: { card: { type: Object, required: true } },
    data() { return { q: "", results: null, loading: true }; },
    computed: {
        ...mapState({ suggested: (s) => s.shell.suggested, defaultLocale: (s) => s.catalog.defaultLocale }),
        lc() { return pickLanguageContent(this.card.languageContent, this.$i18n.locale, this.defaultLocale) || {}; },
        list() { return this.results !== null ? this.results : this.suggested; },
    },
    methods: {
        titleOf(a) { if (a.title) return a.title; const l = pickLanguageContent(a.languageContent, this.$i18n.locale, this.defaultLocale); return l ? l.title : ""; },
        runSearch() {
            const q = this.q.trim();
            if (q.length < 2) { this.results = null; return; }
            this.$store.dispatch("catalog/searchCatalog", { query: q, lang: this.$i18n.locale }).then((r) => { this.results = (r.data || []).map((x) => ({ _id: x._id, title: x.languageContent[0].name, collectionId: x.parentId, slug: x.slug })); }).catch(() => { this.results = []; });
        },
    },
    created() {
        // Debounce ornek basina; methods uzerinde tanimlansa tum kartlar tek zamanlayici paylasir
        this.onSearch = _.debounce(this.runSearch, 300);
    },
    mounted() { this.$store.dispatch("shell/loadSuggested", this.card).catch(() => {}).finally(() => { this.loading = false; }); },
};
</script>



// WEBPACK FOOTER //
// src/components/V2/shell/cards/ArticlesCard.vue